<div mat-dialog-title class="overwrite-margin dialog-title">
  {{ identifier }}
  <button mat-icon-button mat-dialog-close aria-label="Close" style="margin-left: auto">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="separator"></div>
<header>
  <span class="form-field-header mt1">
    <mat-icon>settings</mat-icon>
    Current Configuration
  </span>
</header>
<div class="form-field-container">
  <pre class="config-json">{{ configuration | json }}</pre>
</div>
